import React from 'react'
import Polaroid from './Polaroid'
import Link from './Link'

const PolaroidTeaser = ({ item, className }) => {
  return (
    <section
      className={`stacked-teaser-item stacked-teaser-item-polaroid ${className}`}
    >
      <article>
        <Link link={item.link}>
          <Polaroid image={item.image} caption={item.caption} />
        </Link>
      </article>
    </section>
  )
}

export default PolaroidTeaser
